import { render } from "./PublicationSearchable.vue?vue&type=template&id=1b10437f&scoped=true"
import script from "./PublicationSearchable.vue?vue&type=script&lang=js"
export * from "./PublicationSearchable.vue?vue&type=script&lang=js"

import "./PublicationSearchable.vue?vue&type=style&index=0&id=1b10437f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b10437f"]])

export default __exports__